var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValidDate)?_c('div',{staticClass:"countdown-timer"},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }